// Refresh cart immediately on back/forward navigation to prevent stale cached data
// This runs as early as possible, before deferred scripts load
function refreshCartOnBackNavigation() {
  try {
    const navigation = performance.getEntriesByType('navigation')[0];
    const isBackForward = navigation && navigation.type === 'back_forward';

    if (isBackForward && window.routes && window.routes.cart_url) {
      // Refresh cart icon bubble immediately
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`, { cache: 'no-store' })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sectionElement = html.querySelector('.shopify-section');
            if (sectionElement) {
              cartIconBubble.innerHTML = sectionElement.innerHTML;
            }
          })
          .catch(() => {});
      }

      // Refresh cart drawer immediately
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        fetch(`${window.routes.cart_url}?section_id=cart-drawer`, { cache: 'no-store' })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (let i = 0; i < selectors.length; i += 1) {
              const selector = selectors[i];
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
            const drawerHeading = cartDrawer.querySelector('.drawer__heading');
            const newDrawerHeading = html.querySelector('.drawer__heading');
            if (drawerHeading && newDrawerHeading) {
              drawerHeading.innerHTML = newDrawerHeading.innerHTML;
            }
            const newCartDrawerElement = html.querySelector('cart-drawer');
            if (newCartDrawerElement) {
              const isEmpty = newCartDrawerElement.classList.contains('is-empty');
              cartDrawer.classList.toggle('is-empty', isEmpty);
            }
          })
          .catch(() => {});
      }
    }
  } catch (e) {
    // Silently fail if there is an error
  }
}

refreshCartOnBackNavigation();
